<nav class="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
  <div class="container mx-auto px-4 max-w-7xl">
    <div class="flex justify-between items-center h-16 gap-6">
      <!-- Logo -->
      <div class="flex-shrink-0">
        <a routerLink="/">
          <img ngSrc="/logos/ebba-logo-md.png" alt="EBBA Logo" width="104" height="48"
            class="w-26 h-12 sm:w-20 sm:h-9 md:w-26 md:h-12 object-contain" priority
            sizes="(max-width: 640px) 30vw, (max-width: 768px) 35vw, 40vw" />
        </a>
      </div>

      <!-- Desktop Navigation -->
      <div class="hidden md:flex items-center">
        <ul class="flex items-center space-x-4">
          <ul class="flex items-center gap-4">
            @for (item of menuItems; track item.name) {
            <li class="relative" [class.open]="activeDropdown() === item.name">
              @if (item.children) {
              <!-- Parent item -->
              <button (click)="toggleDropdown(item.name)"
                class="font-poppins text-base text-gray-600 hover:text-primary transition-colors duration-300 px-2 py-1 rounded inline-flex items-center gap-1">
                {{ item.name }}
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 transition-transform duration-300"
                  [class.rotate-180]="activeDropdown() === item.name" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <!-- Dropdown menu -->
              <ul
                class="absolute left-0 overflow-hidden mt-2 w-48 bg-white border border-gray-100 rounded-lg shadow-lg transition-all duration-300 z-50"
                [class.opacity-100]="activeDropdown() === item.name" [class.visible]="activeDropdown() === item.name"
                [class.opacity-0]="activeDropdown() !== item.name" [class.invisible]="activeDropdown() !== item.name">
                @for (child of item.children; track child.link) {
                <li>
                  <a [routerLink]="child.link" (click)="closeDropdown()"
                    class="block px-4 py-2 text-gray-600 hover:text-primary hover:bg-gray-50 transition-colors duration-300">
                    {{ child.name }}
                  </a>
                </li>
                }
              </ul>
              } @else {
              <a [routerLink]="item.link" routerLinkActive="text-primary"
                class="font-poppins text-base text-gray-600 hover:text-primary transition-colors duration-300 px-2 py-1 rounded">
                {{ item.name }}
              </a>
              }
            </li>

            }
          </ul>

        </ul>
      </div>

      <div class="hidden md:flex items-center space-x-4">
        <app-ebba-button label="Contact Us" [link]="['/contact/us']" rounded="full"></app-ebba-button>
        <div class="relative">
          <!-- <button (click)="changeLang()"
            class="bg-white cursor-pointer text-purple-800 font-poppins text-base px-4 py-2 rounded-full border border-gray-200 hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center gap-2 w-full">
            <span>{{lang()}}</span>
            <svg class="w-4 h-4" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button> -->
        </div>
      </div>

      <!-- Mobile Menu Button -->
      <button class="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1.5 relative cursor-pointer"
        (click)="toggleMenu()" [class.active]="isMenuOpen()">
        <span class="w-6 h-0.5 bg-primary transition-all duration-300 origin-center" [class.rotate-45]="isMenuOpen()"
          [class.translate-y-2]="isMenuOpen()"></span>
        <span class="w-6 h-0.5 bg-primary transition-all duration-300" [class.opacity-0]="isMenuOpen()"></span>
        <span class="w-6 h-0.5 bg-primary transition-all duration-300 origin-center" [class.-rotate-45]="isMenuOpen()"
          [class.-translate-y-2]="isMenuOpen()"></span>
      </button>
    </div>
  </div>

  <!-- Mobile Navigation -->
  @if (isMenuOpen()) {
  <div
    class="md:hidden bg-white border-t border-gray-200 motion-preset-slide-down-sm motion-duration-300 motion-ease-in-out">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <ul class="space-y-4">
        @for (item of menuItems; track item.name) {
        <li class="border-b border-gray-100">
          @if (item.children) {
          <button (click)="toggleDropdown(item.name)" class="w-full text-left py-3 flex justify-between items-center">
            {{ item.name }}
            <svg class="w-4 h-4 transition-transform" [class.rotate-180]="activeDropdown() === item.name"
              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          @if(activeDropdown() === item.name){

          <ul class="pl-4 space-y-2">
            @for (child of item.children; track child.link) {
            <li>
              <a [routerLink]="child.link" (click)="closeMenu()" class="block text-gray-600 py-1 hover:text-primary">
                {{ child.name }}
              </a>
            </li>
            }
          </ul>
          }
          } @else {
          <a [routerLink]="item.link" (click)="closeMenu()"
            class="block w-full text-left py-3 text-gray-600 hover:text-primary">
            {{ item.name }}
          </a>
          }
        </li>
        }

        <li class="pt-2">
          <button routerLink="/contact/us" (click)="closeMenu()"
            class="bg-primary text-white font-poppins text-base px-4 py-2 rounded-full hover:bg-primary-900 transition-all duration-300 w-full cursor-pointer">
            Contact Us
          </button>
        </li>
        <!-- <li class="pt-2">
          <div class="w-full">
            <button (click)="changeLang()"
              class="bg-white cursor-pointer text-purple-800 font-poppins text-base px-4 py-2 rounded-full border border-gray-200 hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center gap-2 w-full">
              <span>{{lang()}}</span>
              <svg class="w-4 h-4" viewBox="0 0 16 16" fill="none">
                <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </li> -->
      </ul>
    </div>
  </div>
  }
</nav>